// Provider-neutral seat-map resources. Every symbol here is consumed only
// on the normalized shape (providers/types.js); Amadeus-specific codes,
// blacklists and the notActuallySeats table live in
// providers/amadeus/resources/seat-map.js.

export const displayedAvailability = {
  available: 'disponibile',
  occupied: 'occupato',
  blocked: 'bloccato',
};

/**
 * UI legend factory. Returns seat-component fakes the legend renders,
 * each tagged with a `hint` (or comma-separated set) so seat-map.vue
 * filters to the entries this specific seatmap actually surfaces.
 * Facilities are emitted dynamically per code and resolved through
 * facilityLegend.
 * @param {string} [currencySymbol='€'] Currency symbol for the chargeable swatch
 * @returns {Array<object>}
 */
export const make_seats_legend = (currencySymbol = '€') => [
  {
    hint: 'seat:free',
    type: 'seat',
    currentTravelerPricing: { availability: 'available', price: null },
    legend: 'Posto disponibile (incluso)',
  },
  {
    hint: 'seat:paid,seat:premium',
    type: 'seat',
    currentTravelerPricing: {
      availability: 'available',
      price: { total: '10', grandTotal: '10', currency: '', currencySymbol },
    },
    priceSymbolOnly: true,
    legend: 'Posto disponibile (supplemento)',
  },
  {
    hint: 'seat:free,seat:paid',
    type: 'seat',
    passenger: { id: '1' },
    legend: 'Posto selezionato',
  },
  {
    hint: 'seat:occupied,seat:blocked',
    type: 'seat',
    currentTravelerPricing: { availability: 'blocked', price: null },
    legend: 'Posto non disponibile o inadatto',
  },
  {
    hint: 'seat:infant',
    type: 'seat',
    currentTravelerPricing: { availability: 'available', price: null },
    isSuitableForInfant: true,
    showSuitableForInfant: true,
    legend: 'Adulto con neonato',
  },
  {
    hint: 'exit',
    type: 'exit',
    legend: 'Uscite',
  },
];

// Facility code → human label. seat-map.vue resolves dynamic facility
// hints (`facility:LA:Toilet`) against this table; missing codes fall
// back to the description supplied with the hint, then to the bare code.
export const facilityLegend = {
  LA: 'Servizi',
  WC: 'Servizi',
  G: 'Cucina di bordo',
  GN: 'Cucina di bordo',
  SO: 'Stiva',
  ST: 'Scale',
  BA: 'Bar',
  CL: 'Guardaroba',
};